export default __webpack_public_path__ + "static/media/facebook.8ab44a82.svg";